import styled from "styled-components";

import { StyledAddToListDropdownContent } from "app/pages/sales-intelligence/sub-modules/opportunities/components/miscellaneous/AddToListDropdown/styles";

export const StyledAddToListDropdownWrapper = styled.div`
    button {
        min-width: 128px;
    }

    ${StyledAddToListDropdownContent} {
        right: 0;
        left: unset;
    }
`;
